import Vue from "vue"
import Vuetify from "vuetify/lib"
// import colors from "vuetify/lib/util/colors"

// console.log(localStorage.themes, "-Vuetify")
Vue.use(Vuetify)
export default new Vuetify({
    // theme: {
    //     // dark: Boolean(localStorage.themes),
    //     themes: {
    //         light: {
    //             // primary: colors.purple,
    //             // secondary: colors.grey.darken1,
    //             // accent: colors.shades.black,
    //             // error: colors.red.accent3,
    //             // background: colors.indigo.lighten5, // Added variable
    //         },
    //         dark: {
    //             // primary: colors.indigo.lighten1,
    //             // background: colors.red.accent2,
    //             // // cyan lighten-4
    //             // grey: colors.blue.accent2,
    //             // error: colors.cyan.accent3,
    //             // dark: colors.red.accent2,
    //             // white: colors.cyan.accent2,
    //             // black: colors.grey.lighten1,
    //             // card: colors.red.accent2,
    //         },
    //     },
    // },
})